import { RootState } from '@box/redux/types';

export const loading = (state: RootState) => state.chats.register.loading;
export const error = (state: RootState) => state.chats.register.error;
